import { decodeToHex, decrypt } from './crypto';
export const decryptEncodedEncryptedHolderPassphrase = (encryptedBytesBase64, privateKey)=>{
    const encryptedBytes = decodeToHex(encryptedBytesBase64);
    return decrypt(encryptedBytes, privateKey, 'RSAOAEP512');
};
